import { Copy, Check, Pencil, Save, Trash2 } from "lucide-react";

const btnBase =
  "flex items-center justify-center gap-1.5 rounded-full border py-2.5 text-xs font-semibold transition-colors";

export function DraftActions({
  editing,
  onToggleEdit,
  onCopy,
  copied,
  onDelete,
  copyLabel = "Salin",
  copiedLabel = "Tersalin",
  editTestid,
  copyTestid,
  deleteTestid,
  className = "",
}) {
  return (
    <div className={`grid grid-cols-3 gap-2 ${className}`}>
      <button
        onClick={onToggleEdit}
        data-testid={editTestid}
        className={`${btnBase} border-sk-line text-sk-cream hover:border-sk-brand hover:text-sk-brand`}
      >
        {editing ? <><Save className="h-3.5 w-3.5" /> Simpan</> : <><Pencil className="h-3.5 w-3.5" /> Edit</>}
      </button>
      <button
        onClick={onCopy}
        data-testid={copyTestid}
        className={`${btnBase} border-sk-line text-sk-cream hover:border-sk-brand hover:text-sk-brand`}
      >
        {copied ? <><Check className="h-3.5 w-3.5" /> {copiedLabel}</> : <><Copy className="h-3.5 w-3.5" /> {copyLabel}</>}
      </button>
      <button
        onClick={onDelete}
        data-testid={deleteTestid}
        className={`${btnBase} border-sk-line text-red-600 hover:border-red-500 hover:bg-red-500/5`}
      >
        <Trash2 className="h-3.5 w-3.5" /> Hapus
      </button>
    </div>
  );
}
